import { useQuery } from '@apollo/client';
import { Permission } from '@procureai/permissions';
import { PermissionsProvider as InnerPermissionsProvider } from '@procureai/permissions-ui';
import { filterTruthy } from '@procureai/util';
import { PropsWithChildren, useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';

import { LOAD_PERMISSIONS_QUERY } from './LoadPermissions.gql';

const EMPTY_ARRAY: Permission[] = [];

export const PermissionsProvider = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuth();
  const { data, loading } = useQuery(LOAD_PERMISSIONS_QUERY, {
    fetchPolicy: 'no-cache',
    skip: !isAuthenticated,
  });

  const dataPermissions = data?.getPermissions?.permissions;

  const permissions = useMemo(() => {
    if (dataPermissions) {
      return filterTruthy(dataPermissions);
    }
    return EMPTY_ARRAY;
  }, [dataPermissions]) as Permission[];

  return (
    <InnerPermissionsProvider value={permissions}>
      {loading ? <CircularProgressCentered /> : children}
    </InnerPermissionsProvider>
  );
};
